import React from 'react';
import Reaptcha from 'reaptcha';

const OrderForm = ({ values, errors, handleChange, translations, fetching, captchaRef, verify }) => {
  return (
    <div>
      <div className="tw-form-group tw-mb-4">
        <label className="tw-block tw-text-md tw-text-left tw-font-medium tw-text-gray-900">
          {!fetching && translations[0].i18n.order.name}
          <input
            type="text"
            placeholder={!fetching ? translations[0].i18n.order.name : ''}
            value={values.namn}
            name="namn"
            onChange={handleChange}
            className="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-text-md tw-rounded-lg tw-focus:ring-blue-500 tw-focus:border-blue-500 tw-block tw-w-full tw-p-2.5"
          />
        </label>
        {errors.namn && (<div className="tw-text-red-600">{errors.namn}</div>)}
      </div>
      <div className="tw-form-group tw-mb-4">
        <label className="tw-block tw-text-md tw-text-left tw-font-medium tw-text-gray-900">
          {!fetching && translations[0].i18n.order.address}
          <input
            type="text"
            placeholder={!fetching ? translations[0].i18n.order.address : ''}
            value={values.adress}
            name="adress"
            onChange={handleChange}
            className="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-text-md tw-rounded-lg tw-focus:ring-blue-500 tw-focus:border-blue-500 tw-block tw-w-full tw-p-2.5"
          />
        </label>
        {errors.adress && (<div className="tw-text-red-600">{errors.adress}</div>)}
      </div>
      <div className="tw-form-group tw-mb-4">
        <label className="tw-block tw-text-md tw-text-left tw-font-medium tw-text-gray-900">
          {!fetching && translations[0].i18n.order.zip}
          <input
            type="text"
            placeholder={!fetching ? translations[0].i18n.order.zip : ''}
            value={values.postnr}
            name="postnr"
            onChange={handleChange}
            className="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-text-md tw-rounded-lg tw-focus:ring-blue-500 tw-focus:border-blue-500 tw-block tw-w-full tw-p-2.5"
          />
        </label>
        {errors.postnr && (<div className="tw-text-red-600">{errors.postnr}</div>)}
      </div>
      <div className="tw-form-group tw-mb-4">
        <label className="tw-block tw-text-md tw-text-left tw-font-medium tw-text-gray-900">
          {!fetching && translations[0].i18n.order.city}
          <input
            type="text"
            placeholder={!fetching ? translations[0].i18n.order.city : ''}
            value={values.ort}
            name="ort"
            onChange={handleChange}
            className="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-text-md tw-rounded-lg tw-focus:ring-blue-500 tw-focus:border-blue-500 tw-block tw-w-full tw-p-2.5"
          />
        </label>
        {errors.ort && (<div className="tw-text-red-600">{errors.ort}</div>)}
      </div>
      <div className="tw-form-group tw-mb-4">
        <label className="tw-block tw-text-md tw-text-left tw-font-medium tw-text-gray-900">
          {!fetching && translations[0].i18n.order.email}
          <input
            type="text"
            placeholder={!fetching ? translations[0].i18n.order.email : ''}
            value={values.epost}
            name="epost"
            onChange={handleChange}
            className="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-text-md tw-rounded-lg tw-focus:ring-blue-500 tw-focus:border-blue-500 tw-block tw-w-full tw-p-2.5"
          />
        </label>
        {errors.epost && (<div className="tw-text-red-600">{errors.epost}</div>)}
      </div>
      <div className="tw-form-group tw-mb-4">
        <label className="tw-block tw-text-md tw-text-left tw-font-medium tw-text-gray-900">
          {!fetching && translations[0].i18n.order.phone}
          <input
            type="text"
            placeholder={!fetching ? translations[0].i18n.order.phone : ''}
            value={values.telefon}
            name="telefon"
            onChange={handleChange}
            className="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-text-md tw-rounded-lg tw-focus:ring-blue-500 tw-focus:border-blue-500 tw-block tw-w-full tw-p-2.5"
          />
        </label>
        {errors.telefon && (<div className="tw-text-red-600">{errors.telefon}</div>)}
      </div>
      <div className="tw-form-group tw-mb-4">
        <label className="tw-block tw-text-md tw-font-medium tw-text-gray-900 tw-flex tw-items-center">
          <input
            name="terms"
            type="checkbox"
            checked={values.terms}
            value={true}
            onChange={handleChange}
            className="tw-mr-4 tw-w-6 tw-h-6 tw-text-blue-600 tw-bg-gray-100 tw-border-gray-300 tw-rounded tw-focus:ring-blue-500"
          />
          {!fetching && <span>{translations[0].i18n.order.agree} <a className="tw-underline" rel="noreferrer" target="_blank" href={translations[0].i18n.order.terms_url}>{translations[0].i18n.order.terms}</a></span>}
        </label>
        {errors.terms && (<div className="tw-text-red-600">{errors.terms}</div>)}
      </div>
      <div className="tw-form-group tw-mb-4">
        <label className="tw-block tw-text-md tw-font-medium tw-text-gray-900 tw-flex tw-items-center">
          <input
            name="gdpr"
            type="checkbox"
            checked={values.gdpr}
            value={true}
            onChange={handleChange}
            className="tw-mr-4 tw-w-6 tw-h-6 tw-text-blue-600 tw-bg-gray-100 tw-border-gray-300 tw-rounded tw-focus:ring-blue-500"
          />
          {!fetching && <span>{translations[0].i18n.order.agree} <a className="tw-underline" rel="noreferrer" target="_blank" href={translations[0].i18n.order.policy_url}>{translations[0].i18n.order.policy}</a></span>}
        </label>
        {errors.gdpr && (<div className="tw-text-red-600">{errors.gdpr}</div>)}
      </div>
      <div className="tw-form-group tw-mb-4">
        <Reaptcha 
          sitekey={process.env.REACT_APP_SITE_KEY}
          ref={captchaRef}
          onVerify={verify}
        >
        </Reaptcha>
        {errors.recaptcha && (<div className="tw-text-red-600">{errors.recaptcha}</div>)}
      </div>
    </div>
  );
};

export default OrderForm;
